import { render, staticRenderFns } from "./SiloPropertyView.vue?vue&type=template&id=02b7fd0f"
import script from "./SiloPropertyView.vue?vue&type=script&lang=js"
export * from "./SiloPropertyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports